<div class="left-column-container" [ngStyle]="{'width':leftColumnWidth}">
    @if( isOnPage(UrlConstants.homeUrl) && accountInfo)
    {
    <div id="myAccountInfo" class="left-column-subcontainer">
      <h3 class="crc-heading">My Account Info</h3>
    @if(accountDto.tollFreeNumber || accountDto.groWebId){
    <div class="text-center">
        @if(accountInfo.accountInUnitedStates){
        <span class="accountinfo-sub-class fw-bold">Toll Free Number</span>
        <span>{{accountInfo.accountDto.tollFreeNumber}}</span>
        }

        <div class="my-4 py-2">
            <span [innerHTML]="'GuidanceResources Online&lt;sup&gt;&#174;&lt;/sup&gt;'"
                  class="accountinfo-sub-class fw-bold "></span>
            <span class="accountinfo-sub-class fw-normal">Website</span>
            <a class="crc-link" href="https://www.guidanceresources.com" target="_blank">www.guidanceresources.com</a>
        </div>

        <span class="accountinfo-sub-class fw-normal">Organization Web ID</span>
        <span>{{accountInfo.accountDto.groWebId}}</span>
        <span class="column-container-separator"></span>
    </div>
    }

    <div>
      @if (accountDto.accountName){
    <span class="d-block">{{accountInfo.accountDto.accountName}}</span>
    }
    @if (accountDto.address1){
    <span class="d-block">{{accountInfo.accountDto.address1}}</span>
    }
    @if (accountDto.address2){
    <span class="d-block">{{accountInfo.accountDto.address2}}</span>
    }
    @if (accountDto.city){
    <span class="d-block">{{accountInfo.accountDto.city}}</span>
    }
    @if (accountDto.state){
    <span class="d-block">{{accountInfo.accountDto.state}}</span>
    }
    @if (accountDto.postalCode){
    <span class="d-block">{{accountInfo.accountDto.postalCode}}</span>
    }
    @if (accountDto.postalCode){
    <span class="d-block">{{accountInfo.accountDto.country}}</span>
    }
    @if (!accountInfo.partner && accountDto.employeeCount){
    <span class="d-block">Employee Count:{{accountInfo.accountDto.employeeCount}}</span>
    }
    </div>
    <div>
      <a class="crc-link"  [routerLink]="contactUsUrl">{{contactUsLabel}}</a>
  </div>
</div>
    }
    @if(!accessible(RoleConstants.SHARED_PARTNER) && isOnPage(UrlConstants.homeUrl) && userProfile ){
    <div id="userProfile"  class="left-column-subcontainer">
      <h3 class="crc-heading">My User Profile</h3>
      <div>
        @if (userProfile.fullname){
    <span class="d-block">{{userProfile.fullname}}</span>
    }
    @if (userProfile.title){
    <span class="d-block">{{userProfile.title}}</span>
    }

    @if (userProfile.officePhone){
    <span class="d-block">{{userProfile.officePhone}}</span>
    }

    @if (userProfile.emailAddress){
    <span class="d-block">{{userProfile.emailAddress}}</span>
    }
    @if (userProfile.username && !accessible(RoleConstants.SHARED_PARTNER) && !accessible(RoleConstants.VIEW_CHANGE_PASSWORD_PAGE)){
    <a [class.crc-link-disabled]="userProfile.behalfOf" [routerLink]="UrlConstants.changePasswordUrl"
       class="crc-link">{{"userprofile.label.changePassword"|translate}}</a>
    }
    @if (!userProfile.username){
    <span class="d-block">Note: This person has not registered yet.</span>
    }

    </div>
  </div>
    }

    @if(showYourOpionMatters){
    <div id="yourOpinionMattersBox" class="left-column-subcontainer">
      <h2 class="crc-heading">{{'feedback.opinion.box.title'|translate}}</h2>
    <p>{{'feedback.opinion.box.text'|translate}}</p>
    <a class="crc-link" [routerLink]="feedbackUrl" (click)="onFeedbackLinkClick()">{{
    'feedback.opinion.box.link.submitFeedback'|translate}}</a>
  </div>
    }

    @if(showCism){
    <div id="cismBox" class="left-column-subcontainer">
      <h3 class="crc-heading">CISM</h3>
      <div>
    {{communicationMaterial.cismDescription}}
    @for (material of communicationMaterial.communicationMaterials;track $index){
    <a (click)="commonService.viewFile(material)" class="d-block crc-link" target="_blank">
        {{material.displayName + " (" + material.languageName + " " + material.countryName + ")" }}
        <span> <img alt="pdfIcon" height="16" ngSrc="assets/images/pdf.png" width="16"></span>
    </a>
    }
    <span class="d-block">Call {{accountDto.tollFreeNumber}}</span>
    </div>
  </div>
    }

</div>
